module.exports = __webpack_public_path__ + "img/news-default-thumb.81c9661b.jpeg";